/* Project Import will be here */
import Constants from "../utilities/appConstants";
import { encryptData, decryptData } from "../hooks/security";
/* Project Import will be here */

/* Store user info in local store */
export const saveState = state => {
  try {
    const serializedState = encryptData(JSON.stringify(state));
    localStorage.setItem(Constants.LcKey, serializedState);
  }
  catch (err) {
    /* Ignore write errors. */
  }
};

/* Retrieve user info in local store */

export const loadState = () => {
  try {
    const serializedState = decryptData(localStorage.getItem(Constants.LcKey));

    /* !serializedState.startsWith("{") - this condition is added to test the "uncaught syntaxerror: unexpected token '<'" issue. 
    This fix given for experimental now, if it solves the issue in QA then will consider as actual fix  */
    if (serializedState === null || !serializedState.startsWith("{")) {
      /* If local store data not available return undefined */
      return undefined;
    }

    /* Else parse the local store data and send */
    return JSON.parse(serializedState);
  }
  catch (err) {
    return undefined;
  }
};

/* Store payment request in local store */
export const setIsPaymentRequested = (value: boolean) => {
  try {
    localStorage.setItem(Constants.PAYMENT_REQUESTED, encryptData(value));
  }
  catch (err) {
    /* Ignore write errors. */
  }
}

/* Retrieve payment request in local store */
export const getIsPaymentRequested = () => {
  const isPaymentRequested = decryptData(localStorage.getItem(Constants.PAYMENT_REQUESTED));

  if (isPaymentRequested !== null)
    return isPaymentRequested === 'true';
  else
    return undefined;
}